/**
 * VAT validation via Pillars service-utils (EU VIES).
 * GET /vat/:vat [?country=XX]
 * Set VITE_UTILS_API_ENDPOINT to service-utils base URL; if unset, path is relative to VITE_API_ENDPOINT.
 */
const utilsBase = (import.meta.env.VITE_UTILS_API_ENDPOINT || "").replace(/\/$/, "");
const prefix = (import.meta.env.VITE_API_PREFIX || "").replace(/\/$/, "");

function validateUrl(vat, additional = {}) {
  const vatEnc = encodeURIComponent(String(vat).trim());
  const qs = additional?.country ? `?country=${encodeURIComponent(additional.country)}` : "";
  if (utilsBase) {
    return [`${utilsBase}/vat/${vatEnc}${qs}`];
  }
  const path = prefix ? `${prefix}/vat/${vatEnc}${qs}` : `/vat/${vatEnc}${qs}`;
  return [path];
}

export default {
  get: {
    validate: validateUrl,
  },
};
